(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-pc-selector]').forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const buttons = [...root.querySelectorAll('[data-pc-species]')];
      const setSpecies = (species, updateUrl = true) => {
        if (!['dog', 'cat'].includes(species)) return;
        root.dataset.universe = species;
        buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.pcSpecies === species)));
        root.querySelectorAll('[data-pc-panel]').forEach(panel => { panel.hidden = panel.dataset.pcPanel !== species; });
        const status = root.querySelector('[data-pc-status]');
        if (status) status.textContent = species === 'cat' ? 'La sélection pour les chats est affichée.' : 'La sélection pour les chiens est affichée.';
        if (updateUrl) {
          const url = new URL(window.location.href);
          url.searchParams.set('univers', species === 'cat' ? 'chat' : 'chien');
          window.history.replaceState(null, '', url);
        }
      };
      const readSpecies = () => setSpecies(new URLSearchParams(location.search).get('univers') === 'chat' ? 'cat' : 'dog', false);
      buttons.forEach(button => button.addEventListener('click', () => setSpecies(button.dataset.pcSpecies)));
      document.querySelectorAll('[data-pc-nav-species]').forEach(link => link.addEventListener('click', event => {
        const target = new URL(link.href, location.href);
        if (target.pathname === location.pathname) {
          event.preventDefault();
          setSpecies(link.dataset.pcNavSpecies);
          root.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
          document.querySelectorAll('.pc-mobile-menu[open]').forEach(menu => { menu.open = false; });
        }
      }));
      window.addEventListener('popstate', readSpecies);
      readSpecies();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('.pc-mobile-menu[open]').forEach(menu => {menu.open = false;menu.querySelector('summary').focus();});
  });
})();
